module.exports = __webpack_public_path__ + "static/media/chartEmpty.b7c87f01.svg";